import { useCallback, useEffect, useState } from "react";
import client from "../api/client";

/**
 * Hook to manage dashboard metrics and state
 */
export const useDashboardMetrics = (showNotification) => {
	const [stats, setStats] = useState(null);
	const [loading, setLoading] = useState(true);

	const fetchStats = useCallback(async () => {
		try {
			setLoading(true);
			const response = await client.get("/dashboard/stats");
			setStats(response.data);
		} catch (error) {
			console.error("Error fetching stats:", error);
			if (showNotification) {
				showNotification("Erro ao carregar estatísticas", "error");
			}
		} finally {
			setLoading(false);
		}
	}, [showNotification]);

	useEffect(() => {
		fetchStats();
	}, [fetchStats]);

	const counts = stats?.counts || {};
	const recentProposals = stats?.recentProposals || [];
	const monthlyProposals = stats?.monthlyProposals || [];
	const recentActivity = stats?.recentActivity || [];

	const maxMonthly = Math.max(
		...monthlyProposals.map((m) => parseInt(m.count, 10) || 0),
		1,
	);

	return {
		counts,
		recentProposals,
		monthlyProposals,
		recentActivity,
		maxMonthly,
		loading,
		refresh: fetchStats,
	};
};
